import { connect } from 'react-redux'
import SchoolFilesTable from './school-files-table'
import { getSchoolFilesList } from '../../../../../stores/school-files/school-files.selectors'

const mapStateToProps = state => ({
  schoolFiles: getSchoolFilesList(state)
})

export default connect(mapStateToProps, null)(SchoolFilesTable)
